import { useContext } from "react";
import { AuthContext } from "./AuthContext";
import { Navigate } from 'react-router-dom';


// export const PrivateRoute = ({ children }) => {
//     const { isAuthenticated, isAuthLoading } = useContext(AuthContext);

//     if (isAuthLoading) {
//         return <div>Loading...</div>;   
//     }

//     return isAuthenticated ? children : null;
// };


const ProtectedRoute = ({ children }) => {
    const { isAuthenticated } = useContext(AuthContext);

    if (!isAuthenticated) {
        // Redirect to the home page or login page if not authenticated
        return <Navigate to="/" replace />;
    }

    // Allow access to the protected route if authenticated
    return children;
};

export default ProtectedRoute;